export default __webpack_public_path__ + "static/media/banner3.e1d3ef33.jpg";